module.exports = "<div class='container-fluid'>\n    <app-comics></app-comics>\n    <router-outlet></router-outlet>\n</div>"